import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslocoPipe } from '@ngneat/transloco';
import { twMerge } from 'tailwind-merge';

@Component({
  selector: 'pdf-subtitle-block',
  imports: [NgClass, NgStyle, MatIcon, MatButton, TranslocoPipe],
  templateUrl: './subtitle-block.component.html',
  styleUrl: './subtitle-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfSubtitleBlockComponent {
  @Input() type: 'subtitle' | 'short-subtitle' | 'small-subtitle' = 'short-subtitle';
  @Input() hasEdit: boolean = false;
  @Input() hasEditIcon: boolean = true;
  @Input() hasAddNew: boolean = false;
  @Input() class: string = '';
  @Input() customClass: string = '';
  @Input() titleClass: string = '';
  @Input() style: Record<string, any> | null = null;
  @Input() title: string = '';
  @Input() disabled: boolean = false;
  @Input() editButtonTitle: string = '';
  @Input() addNewTitle: string = '';
  @Input() underline: boolean = false;
  @Input() iconEdit: string = '';
  @Output() edit: EventEmitter<any> = new EventEmitter<any>();
  @Output() addNew: EventEmitter<any> = new EventEmitter<any>();

  get mergedTitleClass() {
    return twMerge(this.hasEdit && 'text-primary underline underline-offset-2', this.titleClass, this.underline ? 'underline underline-offset-2' : '');
  }

  get mergedSubtitleClass() {
    const subtitleClass = this.type === 'subtitle' ? 'subtitle' : this.type === 'short-subtitle' ? 'short-subtitle' : 'small-subtitle';
    return twMerge('flex flex-row items-center w-fit gap-2', subtitleClass, this.hasEdit ? 'cursor-pointer' : '', this.class, this.customClass);
  }

  onEdit() {
    this.edit.emit();
  }

  onAddNew() {
    this.addNew.emit();
  }
}
